import { render, staticRenderFns } from "./ServicesReport.vue?vue&type=template&id=0b3ab6c4&scoped=true"
import script from "./ServicesReport.vue?vue&type=script&lang=js"
export * from "./ServicesReport.vue?vue&type=script&lang=js"
import style0 from "./ServicesReport.vue?vue&type=style&index=0&id=0b3ab6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ab6c4",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Freports%2Fservices-report%2FServicesReport.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports